import { PersonalInformation } from '@tcs/client-portal-api/types/PersonalInformation';
import DetailCard, {
  DetailCardItem,
} from '@tcs/common/components/molecules/DetailCard';
import formatDate from '@tcs/common/utils/formatDate';

interface PersonalInfoCardProps {
  personalInfo: PersonalInformation;
}

const PersonalInfoCard = ({ personalInfo }: PersonalInfoCardProps) => {
  const dateOfBirth = formatDate(personalInfo?.dateOfBirth);
  return (
    <DetailCard title="Personal Information">
      <DetailCardItem label="First Name" value={personalInfo?.firstName} />
      <DetailCardItem label="Last Name" value={personalInfo?.lastName} />
      {!!personalInfo?.nameSuffix && (
        <DetailCardItem label="Suffix" value={personalInfo?.nameSuffix} />
      )}
      <DetailCardItem label="Date of Birth" value={dateOfBirth} isPrivate />
      <DetailCardItem
        label="Social Security Number"
        value={personalInfo?.socialSecurityNumber}
        isPrivate
      />
    </DetailCard>
  );
};

export default PersonalInfoCard;
